// extracted by mini-css-extract-plugin
module.exports = {"Input":"Checkbox_Input__qDWBt","Label":"Checkbox_Label__1l9es","InputElement":"Checkbox_InputElement__3rIJ0","Invalid":"Checkbox_Invalid__1ZaOj"};